export default {
  LAUNCH_RESEARCH: (state, payload) => {
    state.launch_delivery_research = payload.launch_delivery_research;
  },
  LAUNCH_DELIVERY_DETAILS_RESEARCH: (state, payload) => {
    state.launch_delivery_details_research = payload.launch_delivery_details_research;
  },
  RESET_DELIVERY_DETAILS_RESEARCH: state => {
    state.delivery_details_tmod = '';
    state.delivery_details_tcol = '';
    state.delivery_details_ttaille = '';
    state.delivery_details_trefc = '';
  },
  RESET_DELIVERY_RESEARCH: state => {
    state.delivery_tnbl = '';
    state.delivery_tnfact = '';
    state.delivery_tdate_bl = '';
    state.delivery_fncde = '';
  },
  RESET_INVOICE_RESEARCH: state => {
    state.tnfac = '';
    state.tnfac_selected = '';
    state.fdate_fact = '';
    state.fncde = '';
  },
  SELECT: (state, payload) => {
    state[payload.key] = payload.value;
  },
};